import React from "react";

export function PanelFrame({ children, style }) {
  return (
    <div
      style={{
        borderRadius: 8,
        border: "1px solid #4d648d",
        background:
          "radial-gradient(circle at top left, rgba(34,46,72,0.80), rgba(20,29,48,0.80))",
        boxShadow:
          "0 14px 40px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.02)",
        padding: 10,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

